import React from 'react';

const IconHex = () => (
  <svg id="hex" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 97 97">
    <title>Hexagon</title>
    <polygon
      id="Shape"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="2.9 47.5 24.9 86.5 69.9 86.5 92.9 47.5 70.9 8.5 25.9 8.5 2.9 47.5"
      fill="currentColor"
    />
  </svg>
);

export default IconHex;
